import { configureStore } from '@reduxjs/toolkit'
import setting from './reducers/setting';




export const store = configureStore({
    reducer: {
        settings:setting
    },
  })

